import * as types from '@/store/mutation-types'
import moment from 'moment';
export default {
    namespaced: true,
    state: {
        vacationsDayDetails: []
    },
    actions: {
        fetchAll ({ commit }) {
            return window.axios.get('/vacation', { once: true }).then(({ data }) => {
                const disabledDates = []
                for (let i = 0; i < data.length; i++) {
					const fromDate = moment(moment(data[i].fromDate).format('YYYY-MM-DD'));
					const toDate = moment(moment(data[i].toDate).format('YYYY-MM-DD'));
	
					for (let date = fromDate; date.isBefore(toDate) || date.isSame(toDate); date.add(1, 'days')) {
						disabledDates.push(date.format('YYYY-MM-DD'));
					}
				}
                commit(types.STORE_VACATIONS_DAYS_DETAILS, disabledDates)
                return data
            })  
        },

        fetchVacationByFilters({ commit }, { from, to, onlyConstant }) {
            return window.axios.get('/vacation/filters', { params: { from, to, onlyConstant } }).then(({ data }) => {
                return data
            })
        },

        fetchById ({ commit }, { id }) {
            return window.axios.get(`/vacation/${id}`).then((data) => {
                return data
            })
        },

        create ({ commit }, { fromDate, toDate, description, isConstant }) {
            return window.axios.post('/vacation', { fromDate, toDate, description, isConstant }).then(({ data }) => {
                return data
            })
        },

        update ({ commit }, { id, fromDate, toDate, description, isConstant }) {
            return window.axios.put(`/vacation/${id}`, { fromDate, toDate, description, isConstant }).then(({ data }) => {
                return data
            })
        },

        delete ({ commit }, { id }) {
            return window.axios.delete(`/vacation/${id}`)
        },

        reset ({ commit }) {
            commit(types.RESET)
        }
    },
    mutations: {
        // [types.STORE_VACATIONS](state, vacations) {
        //     state.vacations = vacations
        // },
        [types.STORE_VACATIONS_DAYS_DETAILS] (state, vacationsDayDetails) {
            state.vacationsDayDetails = vacationsDayDetails
        },

        [types.RESET](state) {
            state.vacationsDayDetails = []
        }   
    },
    getters: {}
}